import * as Sentry from '@sentry/browser';

// import { useEffect } from 'react';
// import api from 'my-core/api';
import trendingSvg from './error-background.svg';
import Maintenance from './Maintenance';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const rootCss = ({ breakpoints, palette, spacing }) => ({
  height: ['100vh', '100dvh'],
  width: '100vw',
  overflow: 'auto',

  display: 'flex',
  padding: spacing(6, 4),

  backgroundColor: palette.primary.background,

  '.CE-trending': {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '100vw',
  },

  '.CE-content': {
    position: 'relative',
    maxWidth: 900,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    zIndex: 1,
  },
  '.CE-message': {
    width: '100%',
    maxWidth: 500,
    marginTop: 60, // because the maintance image is not properly vertically aligned
    color: palette.primary.dark,
  },
  '.CE-buttons': {
    color: 'initial',
    '& > * + *': { marginLeft: spacing(2) },
  },
  '.CE-maintenance': {
    flex: 1,
    width: 450,
  },

  [breakpoints.down('md')]: {
    '.CE-content': { flexDirection: 'column' },
    '.CE-message': { marginTop: 0 },
    '.CE-maintenance': {
      flex: 'auto',
      width: 250,
    },
    '.CE-trending': { display: 'none' },
  },
  [breakpoints.only('xs')]: {
    '.CE-buttons': {
      display: 'flex',
      flexDirection: 'column',
      '& > * + *': { marginLeft: 0, marginTop: spacing(1) },
    },
  },
});

export default function ClientError({ error, eventId, onResetError }) {
  const isRetryable = error.name === 'ChunkLoadError'; // chunk failed to load

  // useEffect(() => {
  //   if (error)
  //     api.postJSON('/error-reporting', { message: error.message, error: error.toString(), stack: error.stack });
  // }, [error]);

  return (
    <div css={rootCss} id="app-client-error">
      <img alt="trending line graph" className="CE-trending" src={trendingSvg} />
      <div className="CE-content">
        <div className="CE-message">
          <Typography
            gutterBottom
            sx={{
              color: 'inherit',
            }}
            variant="h3"
          >
            Uh oh! There was an error on this page
          </Typography>
          <Typography
            sx={{
              color: 'inherit',
              marginBottom: '16px',
            }}
            variant="body2"
          >
            Head on back to the homepage, and feel free to leave some feedback before you go, it will help us fix the
            problem faster!
          </Typography>
          <div className="CE-buttons">
            <Button component="a" href={window.location.origin} nativeButton={false} size="large" variant="contained">
              Homepage
            </Button>
            {!!eventId && (
              <Button
                color="inherit"
                onClick={() => Sentry.showReportDialog({ eventId: eventId })}
                size="large"
                variant="contained"
              >
                Report Feedback
              </Button>
            )}
            {(__DEV__ || isRetryable) && (
              <Button color="secondary" onClick={onResetError} size="large" variant="contained">
                Retry
              </Button>
            )}
          </div>
        </div>

        <Maintenance className="CE-maintenance" />
      </div>
    </div>
  );
}
